import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";

export default function NewsFooter() {
  return (
    <footer className="bg-foreground-950 text-background-100 mt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-600 text-background-50 text-lg font-bold">
                爆
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-background-50">每日爆料</span>
                <span className="text-[10px] text-background-300/70 mt-1 tracking-[0.2em]">每日快讯 · 新鲜猛料</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-background-300/80 leading-relaxed">
              每日爆料实时更新今日最新即时快讯，聚焦娱乐、社会、财经、科技、体育等热门事件，第一时间送达刚刚发生的新鲜猛料。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#top" aria-label="微博" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-primary-600 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#top" aria-label="微信公众号" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-primary-600 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#top" aria-label="视频号" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-primary-600 transition-colors">
                <i className="ri-vidicon-line"></i>
              </a>
              <a href="#top" aria-label="RSS订阅" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-primary-600 transition-colors">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>

          {/* 栏目导航 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">栏目导航</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-background-300/80 hover:text-accent-300 transition-colors"
                  >
                    {c.name}爆料
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 关于 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300/80 hover:text-accent-300 transition-colors">
                  关于每日爆料
                </Link>
              </li>
              <li>
                <Link to="/about#about-us" className="text-sm text-background-300/80 hover:text-accent-300 transition-colors">
                  发展理念
                </Link>
              </li>
              <li>
                <Link to="/about#about-us" className="text-sm text-background-300/80 hover:text-accent-300 transition-colors">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-300/80 hover:text-accent-300 transition-colors">
                  商务合作
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-300/80 hover:text-accent-300 transition-colors">
                  我要爆料
                </Link>
              </li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-accent-400 mt-0.5"></i>
                <span>
                  爆料邮箱：<span className="text-background-200">baoliao@meiribaoliao.cn</span>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-chat-smile-3-line text-accent-400 mt-0.5"></i>
                <span>客服咨询：工作日 9:00 - 18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-400 mt-0.5"></i>
                <span>欢迎提供线索，我们将认真核实每一条爆料</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-300/60">
          <span>© 2026 每日爆料 MeiriBaoliao · 让刚刚发生的真相更快到达你</span>
          <div className="flex items-center gap-4">
            <a href="#top" className="hover:text-accent-300 transition-colors">免责声明</a>
            <a href="#top" className="hover:text-accent-300 transition-colors">用户协议</a>
            <a href="#top" className="hover:text-accent-300 transition-colors">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}